/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PremiumScheduleResponseDto
 */
export interface PremiumScheduleResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleResponseDto
     */
    premiumScheduleId: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {number}
     * @memberof PremiumScheduleResponseDto
     */
    installmentNumber: number;
    /**
     * 
     * @type {number}
     * @memberof PremiumScheduleResponseDto
     */
    installmentPercent: number;
    /**
     * 
     * @type {Date}
     * @memberof PremiumScheduleResponseDto
     */
    dueDate: Date;
}

/**
 * Check if a given object implements the PremiumScheduleResponseDto interface.
 */
export function instanceOfPremiumScheduleResponseDto(value: object): value is PremiumScheduleResponseDto {
    if (!('premiumScheduleId' in value) || value['premiumScheduleId'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('installmentNumber' in value) || value['installmentNumber'] === undefined) return false;
    if (!('installmentPercent' in value) || value['installmentPercent'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    return true;
}

export function PremiumScheduleResponseDtoFromJSON(json: any): PremiumScheduleResponseDto {
    return PremiumScheduleResponseDtoFromJSONTyped(json, false);
}

export function PremiumScheduleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumScheduleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'premiumScheduleId': json['premiumScheduleId'],
        'contractId': json['contractId'],
        'installmentNumber': json['installmentNumber'],
        'installmentPercent': json['installmentPercent'],
        'dueDate': (new Date(json['dueDate'])),
    };
}

export function PremiumScheduleResponseDtoToJSON(json: any): PremiumScheduleResponseDto {
    return PremiumScheduleResponseDtoToJSONTyped(json, false);
}

export function PremiumScheduleResponseDtoToJSONTyped(value?: PremiumScheduleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'premiumScheduleId': value['premiumScheduleId'],
        'contractId': value['contractId'],
        'installmentNumber': value['installmentNumber'],
        'installmentPercent': value['installmentPercent'],
        'dueDate': ((value['dueDate']).toISOString()),
    };
}

